export default __webpack_public_path__ + "static/media/Product-return-guarantee.e89a7284.svg";